import { useQuery } from '@tanstack/react-query';
import { fetchHalIncotermsList } from '@views/screens/common/data-provider/hal-incoterms-list';

export const useGetHalIncotermsList = () => {
  return useQuery({
    queryKey: ['hal-incoterms-list'],
    queryFn: () => fetchHalIncotermsList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
